import {
  RepositorioBaseComFiltragemDeLeitura,
  OpcoesRepositorioBaseComFiltragemDeLeitura,
} from "@/http"
import { AxiosPromise } from "axios"
import {
  ListarProjetos,
  ParamsProjeto,
  EditarProjeto,
  CriarProjeto,
  ProjetosSimples,
} from "./projeto.modelo"
import { usarSerializador } from "@/composable/UsarSerializador/usarSerializador"
import { ResultadoApiGET } from "@/types/api"

const { paramsSerializer } = usarSerializador()

export class ProjetoRepositorio extends RepositorioBaseComFiltragemDeLeitura {
  public constructor(
    opcoesRepositorio: OpcoesRepositorioBaseComFiltragemDeLeitura = {}
  ) {
    super({
      ...opcoesRepositorio,
      parametrosPadrao: {
        "ordenar-por": ["desc.ativo", "asc.nome_projeto"],
      },
    })
  }
  // se possível evitar de utilizar a rota frontend e utilizar a não frontend
  public listarProjetosFrontend = (
    params?: ParamsProjeto
  ): Promise<ResultadoApiGET<ListarProjetos>> =>
    this.instance.get("/api/frontend/projetos", { params, paramsSerializer })

  public listarProjetos = (
    params?: ParamsProjeto
  ): Promise<ResultadoApiGET<ProjetosSimples>> =>
    this.instance.get("/api/projetos", { params, paramsSerializer })

  public atualizarProjeto = (
    id?: string,
    projeto?: EditarProjeto
  ): Promise<{ id: string }> =>
    this.instance.patch("/api/projetos/" + id, projeto)

  public criarProjeto = (projeto?: CriarProjeto): Promise<{ id: string }> =>
    this.instance.post("/api/projetos", projeto)

  public arquivarProjeto = (id: string): AxiosPromise<{ id: string }> =>
    this.instance.post(`/api/projetos/${id}/desativar`)

  public desarquivarProjeto = (id: string): AxiosPromise<{ id: string }> =>
    this.instance.post(`/api/projetos/${id}/ativar`)

  public deletarProjeto = (id: string): AxiosPromise<void> =>
    this.instance.delete("/api/projetos/" + id)
}

export default ProjetoRepositorio
